import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { selectNode, storeCanvas /* , storeImageData */ } from "../actions";
import { positions, motifs } from "./config/";

/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */

const COLORS = {
  lignes: "#9999FF",
  papier: "#FFFFFF",
  texte: "#333333",
  segments: "#000000",
  axe: "#000000",
  point: "#ff0000"
};
const TICKNESS = {
  axe: 1,
  lignes: 1,
  segments: 4,
  points: 2
};

class Draw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.parameters = {};
    this.onCanvasClick = this.onCanvasClick.bind(this);
    this.onCanvasHover = this.onCanvasHover.bind(this);
  }

  componentDidMount() {
    this.updateSizes();
    window.addEventListener("resize", this.updateSizes.bind(this));
  }
  componentDidUpdate() {
    this.update();
  }
  onCanvasHover(e) {
    const canvas = this.canvas;
    const x = e.nativeEvent.pageX - canvas.offsetLeft;
    const y = e.nativeEvent.pageY - canvas.offsetTop;
    const { copie, width, height } = this.parameters;
    e.preventDefault();
    if (
      y > copie.y - 5 &&
      y < copie.y + height + 5 &&
      x > copie.x - 5 &&
      x < copie.x + width + 5
    ) {
      canvas.classList.add("pointeur");
    } else {
      canvas.classList.remove("pointeur");
    }
  }
  onCanvasClick(e) {
    const canvas = this.canvas;
    e.preventDefault();
    // if (!canvas.classList.contains("pointeur")) {
    //     return false;
    // }
    const obj = e.changedTouches ? e.changedTouches[0] : e.nativeEvent;
    const x = obj.pageX - canvas.offsetLeft;
    const y = obj.pageY - canvas.offsetTop;
    const { copie, width, height, gap } = this.parameters;
    if (
      y > copie.y - 5 &&
      y < copie.y + height + 5 &&
      x > copie.x - 5 &&
      x < copie.x + width + 5
    ) {
      this.props.selectNode([
        Math.round((x - copie.x) / gap) + 1,
        Math.round((y - copie.y) / gap) + 1
      ]);
    }
  }
  selectedNode(node, gap, { x, y }) {
    if (node !== null) {
      const ctx = this.canvas.getContext("2d");
      const xNode = node[0] - 1;
      const yNode = node[1] - 1;
      ctx.fillStyle = COLORS.point;
      ctx.strokeStyle = COLORS.point;
      ctx.beginPath();
      ctx.arc(
        x + xNode * gap,
        y + yNode * gap,
        TICKNESS.points,
        0,
        Math.PI * 2,
        false
      );
      ctx.fill();
      ctx.stroke();
    }
  }
  drawModele({ segments }) {
    const { gap, modele } = this.parameters;
    segments.forEach(segment => this.drawSegment(segment, gap, modele));
  }
  drawCopie({ segments, selected }) {
    const { gap, copie } = this.parameters;
    segments.forEach(segment => this.drawSegment(segment, gap, copie));
    this.selectedNode(selected, gap, copie);
  }
  estimateGridSize() {
    const { width, height } = this.state;
    switch (this.props.position) {
      case positions.LEFT:
        return {
          width: Math.floor(width / 2) - 15,
          height: height - 30
        };
      case positions.RIGHT:
        return {
          width: Math.floor(width / 2) - 15,
          height: height - 30
        };
      case positions.UP:
        return {
          width: width - 30,
          height: Math.floor(height / 2) - 15
        };
      case positions.DOWN:
      default:
        return {
          width: width - 30,
          height: Math.floor(height / 2) - 15
        };
    }
  }
  axe() {
    const { position } = this.props;
    const { width, height } = this.state;

    switch (position) {
      case positions.LEFT:
      case positions.RIGHT:
        return {
          x0: Math.round(width / 2),
          y0: 5,
          x1: Math.round(width / 2),
          y1: height - 15
        };
      case positions.UP:
      case positions.DOWN:
      default:
        return {
          x0: 5,
          y0: Math.round(height / 2),
          x1: width - 5,
          y1: Math.round(height / 2)
        };
    }
  }
  calculateCoordinates(wGrid, hGrid) {
    const { position } = this.props;
    const { width, height } = this.state;

    const margeX = Math.round((width / 2 - wGrid) / 2);
    const margeY = Math.round((height / 2 - hGrid) / 2);
    switch (position) {
      case positions.LEFT:
        return {
          modele: {
            x: margeX,
            y: Math.round((height - hGrid) / 2)
          },
          copie: {
            x: Math.round(width / 2) + margeX,
            y: Math.round((height - hGrid) / 2)
          },
          axe: this.axe()
        };
      case positions.RIGHT:
        return {
          modele: {
            x: Math.round(width / 2) + margeX,
            y: Math.round((height - hGrid) / 2)
          },
          copie: {
            x: margeX,
            y: Math.round((height - hGrid) / 2)
          },
          axe: this.axe()
        };
      case positions.UP:
        return {
          modele: {
            x: Math.round((width - wGrid) / 2),
            y: margeY
          },
          copie: {
            x: Math.round((width - wGrid) / 2),
            y: Math.round(height / 2) + margeY
          },
          axe: this.axe()
        };
      case positions.DOWN:
      default:
        return {
          modele: {
            x: Math.round((width - wGrid) / 2),
            y: Math.round(height / 2) + margeY
          },
          copie: {
            x: Math.round((width - wGrid) / 2),
            y: margeY
          },
          axe: this.axe()
        };
    }
  }
  gridParameters() {
    const { row, col } = this.props.activeModele;
    const { width, height } = this.estimateGridSize();
    const cellSize = Math.floor(
      Math.min(height / (row - 1), width / (col - 1))
    );
    return {
      gap: cellSize,
      width: cellSize * (col - 1),
      height: cellSize * (row - 1),
      ...this.calculateCoordinates(cellSize * (col - 1), cellSize * (row - 1))
    };
  }
  update() {
    const { motif, /* position,  */ activeModele, trace } = this.props;

    this.parameters = this.gridParameters();
    this.whitePaper();

    if (motif === motifs.POINTS) {
      this.drawPoints(activeModele);
    } else {
      this.drawGrid(activeModele);
    }
    this.drawAxis();
    this.drawModele(activeModele);
    this.drawCopie(trace);

    // const canvas = this.canvas;
    // const ctx = canvas.getContext("2d");
    // const { width, height, modele, copie, gap } = this.parameters;
    this.props.storeCanvas(this.canvas);
    // this.props.storeImageData({
    //   modele: ctx.getImageData(modele.x, modele.y, width, height),
    //   copie: ctx.getImageData(copie.x, copie.y, width, height),
    //   gap,
    //   width,
    //   position,
    //   row: activeModele.row,
    //   col: activeModele.col
    // });
  }
  updateSizes() {
    const canvas = this.canvas;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    this.setState({
      width: canvas.width,
      height: canvas.height
    });
  }
  drawSegment(segment, gap, { x, y }) {
    const x0 = segment[0] - 1;
    const y0 = segment[1] - 1;
    const x1 = segment[2] - 1;
    const y1 = segment[3] - 1;
    const ctx = this.canvas.getContext("2d");

    ctx.lineWidth = TICKNESS.segments;
    ctx.strokeStyle = COLORS.segments;
    ctx.fillStyle = COLORS.segments;
    ctx.beginPath();
    ctx.arc(x + x0 * gap, y + y0 * gap, TICKNESS.points, 0, Math.PI * 2, false);
    ctx.moveTo(x + x0 * gap, y + y0 * gap);
    ctx.lineTo(x + x1 * gap, y + y1 * gap);
    ctx.fill();
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(x + x1 * gap, y + y1 * gap, TICKNESS.points, 0, Math.PI * 2, false);
    ctx.fill();
    ctx.stroke();
  }
  drawPoints({ row, col }) {
    const ctx = this.canvas.getContext("2d");
    const { gap, modele, copie } = this.parameters;

    ctx.fillStyle = COLORS.lignes;
    ctx.strokeStyle = COLORS.lignes;
    for (let r = 0; r < row; r++) {
      for (let c = 0; c < col; c++) {
        ctx.beginPath();
        ctx.arc(
          modele.x + c * gap,
          modele.y + r * gap,
          TICKNESS.lignes,
          0,
          Math.PI * 2,
          false
        );
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(
          copie.x + c * gap,
          copie.y + r * gap,
          TICKNESS.lignes,
          0,
          Math.PI * 2,
          false
        );
        ctx.fill();
        ctx.stroke();
      }
    }
  }
  drawGrid({ row, col }) {
    const ctx = this.canvas.getContext("2d");
    const { gap, modele, copie } = this.parameters;

    ctx.lineWidth = TICKNESS.lignes;
    ctx.strokeStyle = COLORS.lignes;
    for (let r = 0; r < row - 1; r++) {
      for (let c = 0; c < col - 1; c++) {
        ctx.strokeRect(modele.x + c * gap, modele.y + r * gap, gap, gap);
        ctx.strokeRect(copie.x + c * gap, copie.y + r * gap, gap, gap);
      }
    }
  }
  drawAxis() {
    const ctx = this.canvas.getContext("2d");
    const { x0, x1, y0, y1 } = this.parameters.axe;
    ctx.lineWidth = TICKNESS.axe;
    ctx.strokeStyle = COLORS.axe;
    ctx.beginPath();
    ctx.moveTo(x0, y0);
    ctx.lineTo(x1, y1);
    ctx.closePath();
    ctx.stroke();
  }
  whitePaper() {
    const ctx = this.canvas.getContext("2d");
    const { width, height } = this.state;

    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = COLORS.papier;
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = COLORS.texte;
    ctx.font = "14px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.fillText("www.micetf.fr", width / 2, height);
  }

  render() {
    return (
      <div id="dessin">
        <canvas
          ref={ref => {
            this.canvas = ref;
          }}
          onClick={this.onCanvasClick}
          onTouchEnd={this.onCanvasClick}
          onMouseMove={this.onCanvasHover}
        />
      </div>
    );
  }
}

Draw.propTypes = {
  position: PropTypes.string.isRequired,
  motif: PropTypes.string.isRequired,
  selectNode: PropTypes.func.isRequired,
  storeCanvas: PropTypes.func.isRequired,
  // storeImageData: PropTypes.func.isRequired,
  trace: PropTypes.shape().isRequired,
  activeModele: PropTypes.shape({
    row: PropTypes.number.isRequired,
    col: PropTypes.number.isRequired
  }).isRequired
};
const mapStateToProps = ({ activeModele, trace, position, motif }) => ({
  activeModele,
  trace,
  position,
  motif
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { selectNode, storeCanvas /* , storeImageData */ },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Draw);
